import { useParams } from 'react-router-dom';
import { getConnectorsMap } from '@components/layouts/Connectors/connectorsMap';
import { assert } from '@/utils/asserts';
import { AuthLoaderFunction } from '@/types/auth';

export const EditConnector = () => {
  const params = useParams();
  const connectorType = params.connectorName as string;
  const connectorComponents = getConnectorsMap().get(connectorType);
  assert(typeof connectorComponents !== 'undefined', 'Wrong connector type provided');
  return connectorComponents.editComponent;
};

export const EditConnectorLoader: AuthLoaderFunction = async (
  { params, request },
  user,
) => {
  const connectorType = params.connectorName as string;
  const connectorComponents = getConnectorsMap().get(connectorType);
  assert(typeof connectorComponents !== 'undefined', 'Wrong connector type provided');
  return await connectorComponents.editLoader(params, request, user);
};
